






























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapState } from "vuex";
import DatePicker from "v-calendar/lib/components/date-picker.umd";

import IconBase from "@/common/components/atoms/IconBase.vue";
import IconCalendar from "@/common/components/icons/IconCalendar.vue";

import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";

@Component({
  components: {
    IconBase,
    IconCalendar,
    DatePicker
  }
})
export default class InputDate extends Vue {
  @Prop({ type: String, required: true }) name!: string;
  @Prop({ type: String, required: false }) error!: string;
  @Prop({ type: String, required: false }) placeholder!: string;
  @Prop({ type: String, required: false }) minDate!: string;
  @Prop({ type: String, required: false }) maxDate!: string;
  @Prop({ type: [Date, Boolean], required: false }) initValue!: any;
  @Prop({ type: Boolean, required: false }) isRight!: boolean;

  dateNew: any;
  masksOptions = {
    L: "YYYY/MM/DD",
    title: "YYYY年 MMM"
  };
  themesOptions = {
    container: "p-form-datepicker",
    title: "p-form-datepicker__title",
    arrows: "p-form-datepicker__arrows",
    bgAccentHigh: "p-form-datepicker__selected",
    weekdays: "p-form-datepicker__weekdays",
    dayContent: "p-form-datepicker__day",
    dayContentDisabled: "p-form-datepicker__day--disabled"
  };

  updateValue(value: string) {
    if (value) this.$emit("input", { value, name: this.name });
  }

  get color(): string {
    return commons.color;
  }

  get browser() {
    return globals.browser;
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get datePickerTheme() {
    return `p-form-datepicker p-form-datepicker--${this.color}`;
  }

  get inputClass(): string {
    let inputClass = "c-input-date c-input-date--has_icon";
    if (this.error) inputClass += " c-input-date--error";
    return inputClass;
  }

  get popoverOptions() {
    return {
      visibility: "focus",
      placement: this.isSp && this.isRight ? "bottom-end" : "bottom-start",
      positionFixed: true
    };
  }

  get isIe() {
    return globals.browser === "ie";
  }

  mounted() {
    this.dateNew = this.initValue;
    this.themesOptions.bgAccentHigh = `p-form-datepicker__selected p-form-datepicker__selected--${this.color}`;
  }
}
